import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import styled from "@emotion/styled";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { yupResolver } from "@hookform/resolvers/yup";
import { Grid, MenuItem } from "@mui/material";
import { useForm, FormProvider } from "react-hook-form";
import useEmployee from "../../../../hooks/useEmployee";
import useEmailMaster from "../../../../hooks/useEmailMaster";
import useBranch from "../../../../hooks/useBranch";

import SearchableAutoComplete from "../../../../components/SearchableAutoComplete";
import FilterReset from "../../../../components/FilterReset";
import { searchPayload, convertedValue } from "../../../../utils/common";
import { OperatorConstants } from "../../../../constants/operator.constants";
import ReactHookFormSelect from "../../../../components/ReactHookFormSelect";
import CustomTextField from "../../../../components/CustomTextField";
import { useDialog } from "../../../../contexts/DialogContext";

const currentPayload = {
  filters: [],
  pagination: {
    pageNumber: 1,
    pageSize: 100,
  },
  sortFields: [],
};

const statusOptions = [
  {
    label: "Active",
    value: "A",
  },
  {
    label: "InActive",
    value: "INA",
  },
];

function AdvanceFilter(props) {
  const { unSetDialog } = useDialog();
  const initialValues = {
    emailTemplateNameOperator: "eq",
    emailTemplateCodeOperator: "eq",
    statusOperator: "eq",
    emailTemplateName: [],
    emailTemplateCode: "",
    status: [],
  };

  const { fields, payload, setPayload, setFilterResetFunc } = props;

  const { autoSearchEmailMaster, emailMasterAutoSearchResults, isLoadingAutoSearch } =
    useEmailMaster();

  const [emailMasterPayload, setEmailMasterPayload] = useState(currentPayload);
  const [emailMasterOptions, setEmailMasterOptions] = useState([]);
  const [emailMasterMultiValue, setEmailMasterMultiValue] = useState(false);
  const [statusMultiValue, setStatusMultiValue] = useState(false);

  const [defaultEmailMaster, setDefaultEmailMaster] = useState([]);

  const [defaultStatus, setDefaultStatus] = useState([]);

  const { t } = useTranslation();
  const methods = useForm({
    defaultValues: initialValues,
  });

  const {
    reset,
    handleSubmit,
    formState: { errors },
    control,
    watch,
    setValue,
  } = methods;

  useEffect(() => {
    setFilterResetFunc(() => reset);
  }, [reset]);

  const emailMasterOpValue = watch("emailTemplateNameOperator");

  const statusOpValue = watch("statusOperator");

  const onSubmit = async (data) => {
    try {
      let filters = [];

      if (data.emailTemplateName != null && Object.keys(data.emailTemplateName).length != 0) {
        filters.push({
          fieldName: "emailTemplateId",
          fieldValue: convertedValue(data.emailTemplateName, "value").join(","),
          op: data.emailTemplateNameOperator,
          dataType: "int",
          condition: "and",
          isJoin: false,
        });
      }
      if (data.emailTemplateCode != "" && data.emailTemplateCode != null) {
        filters.push({
          fieldName: "emailTemplateCode",
          fieldValue: data.emailTemplateCode,
          op: data.emailTemplateCodeOperator,
          dataType: "string",
          condition: "and",
          isJoin: false,
        });
      }
      if (data.status != null && Object.keys(data.status).length != 0) {
        filters.push({
          fieldName: "status",
          fieldValue: convertedValue(data.status, "value").join(","),
          op: data.statusOperator,
          dataType: "string",
          condition: "and",
          isJoin: false,
        });
      }
      setPayload({
        ...payload,
        filters: filters,
      });
      unSetDialog("advance_filter");
    } catch (err) {
      console.log(err, "errerrerrerr");
    }
  };

  useEffect(() => {
    if (emailMasterOpValue == "in" || emailMasterOpValue == "nin") {
      setDefaultEmailMaster([]);
      setValue("emailTemplateName", []);
      setEmailMasterMultiValue(true);
    } else {
      setDefaultEmailMaster({});
      setValue("emailTemplateName", {});
      setEmailMasterMultiValue(false);
    }
  }, [emailMasterOpValue]);

  useEffect(() => {
    if (statusOpValue == "in" || statusOpValue == "nin") {
      setDefaultStatus([]);
      setValue("status", []);
      setStatusMultiValue(true);
    } else {
      setDefaultStatus({});
      setValue("status", {});
      setStatusMultiValue(false);
    }
  }, [statusOpValue]);

  const fetchEmailMaster = async () => {
    await autoSearchEmailMaster(emailMasterPayload);
  };
  useEffect(() => {
    fetchEmailMaster();
  }, [emailMasterPayload]);

  useEffect(() => {
    if (emailMasterAutoSearchResults.data.length !== 0) {
      setEmailMasterOptions([...emailMasterOptions, ...emailMasterAutoSearchResults.data]);
    }
  }, [emailMasterAutoSearchResults]);

  return (
    <React.Fragment>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={4} pt={8}></Grid>

          <Grid container spacing={12} pt={8}>
            <Grid item xs={9.5} sm={12} md={6} lg={6} xl={4}>
              <ReactHookFormSelect
                name="emailTemplateNameOperator"
                label={t("Operator")}
                control={control}
                fullWidth
                variant="outlined"
                fields={fields}
                errors={errors}
              >
                {Object.entries(OperatorConstants.dropdown).map((value, k) => (
                  <MenuItem key={k} value={value[0]}>
                    {value[1]}
                  </MenuItem>
                ))}
              </ReactHookFormSelect>
            </Grid>
            <Grid item xs={9.5} sm={12} md={6} lg={6} xl={4}>
              <SearchableAutoComplete
                control={control}
                data={emailMasterOptions}
                label={t("template_name")}
                payload={emailMasterPayload}
                setPayload={setEmailMasterPayload}
                loading={isLoadingAutoSearch}
                name="emailTemplateName"
                multiple={emailMasterMultiValue}
                defaultValue={defaultEmailMaster}
              />
            </Grid>
            <Grid item xs={9.5} sm={12} md={6} lg={6} xl={4}>
              <ReactHookFormSelect
                name="emailTemplateCodeOperator"
                label={t("Operator")}
                control={control}
                fullWidth
                variant="outlined"
                fields={fields}
                errors={errors}
              >
                {Object.entries(OperatorConstants.string).map((value, k) => (
                  <MenuItem key={k} value={value[0]}>
                    {value[1]}
                  </MenuItem>
                ))}
              </ReactHookFormSelect>
            </Grid>
            <Grid item md={6}>
              <CustomTextField
                label={t("template_code")}
                name="emailTemplateCode"
                control={control}
                fullWidth
                variant="outlined"
                errors={errors}
              />
            </Grid>
          </Grid>
          <Grid container spacing={12} pt={8}>
            <Grid item xs={9.5} sm={12} md={6} lg={6} xl={4}>
              <ReactHookFormSelect
                name="statusOperator"
                label={t("Operator")}
                control={control}
                fullWidth
                variant="outlined"
                fields={fields}
                errors={errors}
              >
                {Object.entries(OperatorConstants.dropdown).map((t, k) => (
                  <MenuItem key={k} value={t[0]}>
                    {t[1]}
                  </MenuItem>
                ))}
              </ReactHookFormSelect>
            </Grid>
            <Grid item xs={9.5} sm={12} md={6} lg={6} xl={4}>
              <SearchableAutoComplete
                control={control}
                data={statusOptions}
                label={t("Status")}
                payload={null}
                setPayload={null}
                loading={false}
                name="status"
                multiple={statusMultiValue}
                defaultValue={defaultStatus}
              />
            </Grid>
          </Grid>
          <FilterReset resetForm={reset} />
        </form>
      </FormProvider>
    </React.Fragment>
  );
}

export default AdvanceFilter;
